export const ru = {
  entities: {
    fieldTypes: {
      text: 'Строка',
      longText: 'Многострочный текст',
      number: 'Число',
      rating: 'Оценка (0.5–5)',
      boolean: 'Да/нет',
      date: 'Дата',
      url: 'Ссылка',
      select: 'Выбор из списка',
      reference: 'Ссылка на запись',
    },
    editor: {
      fields: 'Поля',
      addField: 'Добавить поле',
      label: 'Подпись',
      type: 'Тип',
      key: 'Ключ: {key}',
      required: 'Обязательное',
      multiple: 'Несколько значений',
      options: 'Варианты (по одному в строке)',
      target: 'Ссылается на',
      targetPosts: 'Посты',
      removeField: 'Удалить поле',
      removeWarning: 'Значения этого поля будут стёрты во всех записях ({n}).',
      noFields: 'Полей пока нет — добавьте первое.',
      typeLocked: 'Тип существующего поля не меняется',
    },
    types: {
      title: 'Справочники',
      subtitle: 'Свои типы записей: заведения, рестораторы, рубрики — с нужными полями.',
      create: 'Новый справочник',
      name: 'Название (ед. ч.)',
      pluralName: 'Название (мн. ч.)',
      titleField: 'Поле-заголовок записи',
      titleFieldHint: 'Обязательное текстовое поле, по нему ищутся записи.',
      defaultTitleLabel: 'Название',
      countPlural: { one: '{n} запись', few: '{n} записи', many: '{n} записей', other: '{n} записи' },
      empty: 'Справочников пока нет',
      emptyText: 'Например, «Заведение» с адресом и ссылкой на карты.',
      deleteConfirm: 'Удалить справочник «{name}»?',
      edit: 'Изменить справочник',
    },
    postFields: {
      title: 'Поля постов',
      subtitle: 'Дополнительные поля каждого поста, например «Оценка» и ссылка на заведение.',
    },
    list: {
      search: 'Поиск по заголовку',
      create: 'Новая запись',
      empty: 'Записей пока нет',
      emptySearch: 'Ничего не найдено',
      sortTitle: 'По названию',
      sortUpdated: 'По изменению',
      sort: 'Сортировка',
    },
    card: {
      backlinks: 'Ссылаются на запись',
      noBacklinks: 'Пока ни пост, ни запись не ссылаются сюда.',
      deleteConfirm: 'Удалить запись «{title}»?',
      blocked: 'Удалить нельзя — на запись ссылаются:',
      newTitle: 'Новая запись: {type}',
      post: 'Пост',
    },
    reference: {
      search: 'Начните вводить название',
      choose: 'Не выбрано',
    },
  },
};

export const en: typeof ru = {
  entities: {
    fieldTypes: {
      text: 'Text',
      longText: 'Long text',
      number: 'Number',
      rating: 'Rating (0.5–5)',
      boolean: 'Yes/no',
      date: 'Date',
      url: 'Link',
      select: 'Choice',
      reference: 'Link to record',
    },
    editor: {
      fields: 'Fields',
      addField: 'Add field',
      label: 'Label',
      type: 'Type',
      key: 'Key: {key}',
      required: 'Required',
      multiple: 'Multiple values',
      options: 'Options (one per line)',
      target: 'Links to',
      targetPosts: 'Posts',
      removeField: 'Remove field',
      removeWarning: 'Values of this field will be erased in all records ({n}).',
      noFields: 'No fields yet — add the first one.',
      typeLocked: "An existing field's type can't change",
    },
    types: {
      title: 'References',
      subtitle: 'Your own record types: venues, restaurateurs, columns — with the fields you need.',
      create: 'New reference',
      name: 'Name (singular)',
      pluralName: 'Name (plural)',
      titleField: 'Record title field',
      titleFieldHint: 'A required text field used to find records.',
      defaultTitleLabel: 'Name',
      countPlural: { one: '{n} record', few: '{n} records', many: '{n} records', other: '{n} records' },
      empty: 'No references yet',
      emptyText: 'For example, “Venue” with an address and a map link.',
      deleteConfirm: 'Delete reference “{name}”?',
      edit: 'Edit reference',
    },
    postFields: {
      title: 'Post fields',
      subtitle: 'Extra fields for every post, e.g. “Rating” and a link to the venue.',
    },
    list: {
      search: 'Search by title',
      create: 'New record',
      empty: 'No records yet',
      emptySearch: 'Nothing found',
      sortTitle: 'By name',
      sortUpdated: 'By update',
      sort: 'Sort',
    },
    card: {
      backlinks: 'Linked from',
      noBacklinks: 'No posts or records link here yet.',
      deleteConfirm: 'Delete record “{title}”?',
      blocked: "Can't delete — linked from:",
      newTitle: 'New record: {type}',
      post: 'Post',
    },
    reference: {
      search: 'Start typing a title',
      choose: 'Not selected',
    },
  },
};
